import React, { Component } from 'react';
import Select from 'react-select';
import '../../Asset/Css/util.css';
import '../../Asset/Css/style.bundle.css';
import '../../Asset/custom.css';
import axios from 'axios';
import { config } from '../../Constants';
import { Link } from 'react-router-dom';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'reactjs-popup/dist/index.css';
import Modal from "../Modal";
import global from '../global';
import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import { store } from 'react-notifications-component';
import Spinner from '../Spinner';


export class ForgetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Type: 'F',
            emailID: '',
            OTP: '',
            PAN: '',
            RemitterLogo: 'client-logo.png',
            RemitterStyle: '80%',
            remitterID: 0,
            remitterCode: '',
            URL: '',
            formErrors: '',
            isEmail: false,
            showEmail: 'none',
            showValidate: 'none',
            showValidateNew: 'none',
            showTiming: 'none',
            showReOTP: 'none',
            showGanerate: 'block',
            loading: false,
            panDisable: false,
            emailDisable: false,
            Website: 'https://www.nexdigm.com/',
            time: {}, seconds: 300, isFirstClick: 0, emailDr: []
        };
        this.timer = 0;
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);

        axios.get(global.UserManagement.GetSessionDetailsAPI)
            .then(response => {
                if (response.data.Status) {
                    this.setState({
                        remitterCode: response.data.RemitterCode,
                        remitterID: response.data.RemitterID,
                        RemitterLogo: response.data.RemitterLogo,
                        RemitterStyle: response.data.RemitterStyle,
                        Website: response.data.Website,
                        URL: config.url.Web_URL + '/' + response.data.RemitterCode
                    });

                } else {
                    window.location.href = config.url.Web_URL + `/Error/404`;
                    return;
                }
            })
            .catch(error => {
                console.log(error);
            });

        this.initialState = this.state;
    }

    secondsToTime(secs) {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    startTimer() {
        if (this.timer == 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown() {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;
        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
        });

        // Check if we're at zero.
        if (seconds == 0) {
            clearInterval(this.timer);
            this.setState({ showReOTP: 'block', showTiming: 'none' });
        }
    }

    showNoti(title, message, type) {

        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });

    };

    handleCancel = (e) => {
        e.preventDefault();
        window.location.href = this.state.URL;
    }

    handlePANChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value.toUpperCase() });
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleValidate(e) {
        if (this.state.otp == '') {
            this.showNoti("Notification", "Please enter OTP.", "danger");
        } else {
            axios.post(global.UserManagement.ValidateOtpAPI + this.state.otp + '&PAN=' + this.state.PAN + '&Email=' + this.state.emailID)
                .then(json => {
                    if (json.data.status) {
                        window.location.href = this.state.URL + '/userProfile?bD=' + window.btoa(this.state.PAN) + '&rD=' + window.btoa(json.data.remitterID) + '&ReqType=' +window.btoa('F');
                    }
                    else {
                        this.showNoti("Notification", json.data.message, "danger");
                    }
                });
        }
    }

    handleVerifyPAN = (e) => {

        if (this.state.PAN == '' || this.state.PAN == undefined) {
            this.showNoti("Notification", "PAN is required.", "danger");
            return;
        }

        var regex = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

        if (!regex.test(this.state.PAN.toUpperCase())) {
            this.showNoti("Notification", "PAN is not valid.", "danger");
            return;
        }

        this.setState({ loading: true });

        axios.post(global.UserManagement.VerifyPANAPI + '?PAN=' + this.state.PAN.toUpperCase() +'&Type=F')
            .then(json => {
                if (json.data.status) {
                    this.setState({ loading: false });
                    this.showNoti("Notification", "PAN Verified Successfully.", "success");

                    const optionsEmail = json.data.List.map(d => ({
                        "value": d.EmailID,
                        "label": d.EmailID
                    }))
                    this.setState({ emailDr: optionsEmail, showValidate: 'block', showEmail: 'block', panDisable: true, showGenerate: 'none', showValidateNew: 'none', emailID: json.data.List[0].EmailID })
                }
                else {
                    this.setState({ loading: false });

                    this.showNoti("Notification", json.data.message, "danger");

                }
            })


    }

    handleSubmit = (e) => {

        if (this.state.PAN == '' || this.state.PAN == undefined) {
            this.showNoti("Notification", "PAN is required.", "danger");
            return;
        }

        var regex = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

        if (!regex.test(this.state.PAN)) {
            this.showNoti("Notification", "PAN is not valid.", "danger");
            return;
        }

        if (this.state.emailID == '' || this.state.emailID == undefined || this.state.emailID == null) {
            this.showNoti("Notification", "Email is required.", "danger");
            return;
        }

        this.setState({ loading: true });

        const verifyProfile = this.state;
        this.state.remitterID = 0;

        axios.post(global.UserManagement.VerifyUserAPI, verifyProfile)
            .then(json => {
                if (json.data.status) {

                    if (this.state.isFirstClick == 0) {
                        this.timer = setInterval(this.countDown, 1000);
                        this.setState({ isEmail: true, showTiming: 'block', showReOTP: 'none', showValidate: 'none', showEmail: 'block', showGenerate: 'none', showValidateNew: 'block', loading: false, time: {}, seconds: 300, isFirstClick: 1, panDisable: true, emailDisable: true });
                        this.showNoti("Notification", "OTP sent successfully; check on your registered email.", "success");

                    }
                    else {
                        this.setState({ isEmail: true, showTiming: 'block', showReOTP: 'none', showValidate: 'none', showEmail: 'block', showGenerate: 'none', showValidateNew: 'block', loading: false, time: {}, seconds: 300, isFirstClick: 1, panDisable: true, emailDisable: true });
                        this.showNoti("Notification", "OTP sent successfully; check on your registered email.", "success");
                    }
                }
                else {
                    this.setState({ loading: false });
                    if (json.data.message == 'Beneficiary details not found!') {
                    }
                    this.showNoti("Notification", "It seems that Email & PAN combination provided is not registered with us. Kindly contact " + this.state.remitterCode, "danger");

                }
            })


    }

    handleEmailChange(e) {

        if (e.value != undefined) {
            this.setState({ emailID: e.label });
        }
    }

    render() {
        if (this.state.loading) return <Spinner />;
        return (
            <div>
                <ReactNotification />

                <div className="m-grid m-grid--hor m-grid--root m-page">
                    <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--signin m-login--2 m-login-2--skin-1" id="m_login">
                        <div className="m-grid__item m-grid__item--fluid m-login__wrapper">
                            <div className="m-login__container">
                                <div className="row m-row--no-padding m-row--col-separator-xl">
                                    <div className="col-md-6 col-lg-6 col-xl-6 col-sm-12">
                                        <div className="reporting-portal">
                                            <img src={process.env.PUBLIC_URL + "/Images/EasyDiviend_Client_logo.png"} />
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-lg-6 col-xl-6 col-sm-12">
                                        <div className="reporting-portal-right">
                                            <div className="reporting-portal-banner">
                                                <img src={process.env.PUBLIC_URL + "/Images/" + this.state.RemitterLogo} width={this.state.RemitterStyle} />
                                            </div>
                                            <div className="m-login__signin">
                                                <div className="m-login__form m-form" action="">
                                                    <div className="m-login__head">
                                                        <h3 className="m-login__title align-left">
                                                            FORGOT PASSWORD?    
                                                        </h3>
                                                        <span className="p-b-20">
                                                            A OTP will be sent to your email to reset your password. If you don't get an email within a few minutes, please re-try.
                                                        </span>
                                                    </div>

                                                    <div className="form-group m-form__group">
                                                        <label>
                                                            PAN
                                                        </label>
                                                        <input disabled={this.state.panDisable} className="form-control m-input m-input--solid PAN" type="text" name="PAN" value={this.state.PAN} onChange={this.handlePANChange} placeholder="Format: AAAAA1234A" maxLength="10" autoComplete="new-password" />
                                                    </div>
                                                    <div className="form-group m-form__group" style={{ display: `${this.state.showEmail}` }}>
                                                        <label>
                                                            Email
                                                        </label>
                                                        <Select
                                                            className="form-control m-input m-input--solid"
                                                            classNamePrefix="Select Email"
                                                            value={this.state.emailDr.find(obj => obj.label === this.state.emailID)}
                                                            options={this.state.emailDr}
                                                            onChange={this.handleEmailChange.bind(this)}
                                                            isDisabled={this.state.emailDisable}
                                                        />
                                                    </div>
                                                    <div className="form-group m-form__group" style={{ display: `${this.state.showValidateNew}` }}>
                                                        <label>
                                                            OTP
                                                        </label>
                                                        <input className="form-control m-input m-input--solid" type="text" placeholder="OTP"
                                                            name="otp" value={this.state.otp} onChange={this.handleChange} placeholder="Format: 123456" autoComplete="new-password" />
                                                    </div>
                                                    <div className="m-login__form-action" style={{ display: `${this.state.showValidateNew}` }}>
                                                        <button type="button" id="m_login_signup_submit" onClick={(id = 1) => this.handleValidate()} className="btn btn-focus m-btn m-btn--pill m-btn--custom m-login__btn m-login__btn--primary" >
                                                            VALIDATE OTP
                                                        </button>
                                                    </div>
                                                    <div className="m-login__form-action" style={{ display: `${this.state.showGenerate}` }}>
                                                        <button type="button"  className="btn btn-focus m-btn m-btn--pill m-btn--custom m-login__btn m-login__btn--primary" onClick={this.handleVerifyPAN}>
                                                            VERIFY
                                                        </button>
                                                    </div>
                                                    <div className="m-login__form-action" style={{ display: `${this.state.showValidate}` }}>
                                                        <button type="button" className="btn btn-focus m-btn m-btn--pill m-btn--custom m-login__btn m-login__btn--primary" onClick={this.handleSubmit}>
                                                            GENERATE OTP
                                                        </button>
                                                    </div>

                                                </div>
                                                <div className="m-login__account" style={{ display: `${this.state.showTiming}` }}>
                                                    <button className="m-link m-link--light m-login__account-link" > Time Remaining: {this.state.time.m} : {this.state.time.s}  </button>
                                                </div>
                                                <div className="m-login__account" style={{ display: `${this.state.showReOTP}` }}>
                                                    <button onClick={this.handleSubmit} className="m-link m-link--light m-login__account-link" > Click Here to Re-Generate OTP  </button>
                                                </div>

                                                <div className="m-login__account" style={{ display: `${this.state.showGenerate}` }}>
                                                    <button onClick={this.handleCancel} className="m-link m-link--light m-login__account-link" > Already have an Account? Sign In  </button>
                                                </div>
                                            </div>
                                            <div className="reporting-portal-banner p-t-0 p-b-20">
                                                <span>Powered by </span><img src={process.env.PUBLIC_URL + "/Images/nexdigm-logo-sm.png"} className="powered-footer" />
                                                <br /><span className="f-m-m"> Reach out to us at <a href="mailto:dividend.support@nexdigm.com" className="txt_a">dividend.support@nexdigm.com</a> for any queries.</span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                
            </div>
        );
    }

}

